import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const CompanyId = z.coerce.number().int().positive();
const SessionId = z.coerce.number().int().positive();
const CompanyParams = z.object({ companyId: CompanyId });
const SessionParams = CompanyParams.extend({
    assessmentTestSessionId: SessionId,
});
// These aggregate responses are assembled from several database queries and
// already have stable TypeScript shapes in the frontend. The object boundary
// is explicit while preserving fields added by the existing handlers.
const AggregateResponse = z.object({}).passthrough();
export const getCompanyRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/companies/{companyId}',
    name: 'get-company',
    request: { params: CompanyParams },
    responses: {
        200: AggregateResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const getCompanyOfficeHoursRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/companies/{companyId}/office-hours',
    name: 'get-company-office-hours',
    request: { params: CompanyParams },
    responses: {
        200: AggregateResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const getCompanyAssessmentTestsRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/companies/{companyId}/tests',
    name: 'get-company-assessment-tests',
    request: { params: CompanyParams },
    responses: {
        200: AggregateResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const getAssessmentTestSessionRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/companies/{companyId}/tests/sessions/{assessmentTestSessionId}',
    name: 'get-assessment-test-session',
    request: { params: SessionParams },
    responses: {
        200: AggregateResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const getExerciseSubmissionsRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/companies/{companyId}/submissions',
    name: 'get-exercise-submissions',
    request: { params: CompanyParams },
    responses: {
        200: AggregateResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const getCompanyProjectSubmissionsRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/companies/{companyId}/company-projects',
    name: 'get-company-project-submissions',
    request: { params: CompanyParams },
    responses: {
        200: AggregateResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const getCompaniesRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/companies',
    name: 'get-companies',
    request: {},
    responses: {
        200: z.object({ items: z.array(AggregateResponse) }),
        400: HttpErrorResponse,
    },
};
